<template>
  <div id="Clientes" 
  v-if="$store.state.global_privilegio_admin_registro_cliente.ver">
    <AdminMenu />
    <div class="container">
      <div class="row justify-content-center align-items-center">
        <div class="col-12">
          <div class="row container_admin">
            <!-- LISTA DE CLIENTES -->
            <div class="col-6 text-left mt-2">
              <b class="titulo">Clientes</b>
            </div>
            <div class="col-6 d-flex justify-content-end mt-2">
              <button
                v-show="$store.state.global_privilegio_admin_registro_cliente.crear"
                type="button"
                class="btn boton_guardar1 mr-2"
                data-toggle="modal"
                data-target="#agregarcliente"
                style="width: 180px !important"
              >
                <img src="img/iconos/registro_cliente.png" alt="logo-color" class="icono" />Nuevo cliente
              </button>
              <!-- BOTÓN MODAL DESCARGAR EXCEL -->
              <button
                class="btn boton_guardar1 mr-3"
                data-toggle="modal"
                data-target="#descargarexcel"
                @click="descargar_excel"
                style="width: 180px !important"
              >
                Descargar Excel
              </button>
            </div>
            <div class="col-12 table mt-3">
              <v-client-table
                class="col-12 mt-3"
                :columns="columns"
                :data="informacion"
                :options="options"
              >
                <div slot="estado" slot-scope="props">
                  <button type="button" class="btn btn-success"
                    v-if="props.row.estado_cliente == 'En Servicio'" data-toggle="modal"
                    data-target="#estadoClienteSin" title="¿Desea cambiar el estado del Servicio?"
                    @click="consultar_cliente(props.row.id)">En Servicio</button>
                  <button type="button" class="btn btn-danger"
                    v-if="props.row.estado_cliente == 'Sin Servicio'"
                    data-toggle="modal" data-target="#estadoClienteCon"
                    @click="consultar_cliente(props.row.id)"
                    title="¿Desea cambiar el estado del Servicio?"
                  >
                    Sin Servicio
                  </button>
                </div>
                <div slot="opciones" slot-scope="props">
                  <button class="btn dropdown-toggle" data-toggle="dropdown" aria-expanded="false"></button>
                  <ul class="dropdown-menu b-dropdown-opt" role="menu">
                    <li>
                      <a
                        class="btn btn-block boton_opciones" data-toggle="modal" data-target="#editarcliente"
                        @click="consultar_cliente(props.row.id)"
                        v-show="$store.state.global_privilegio_admin_registro_cliente.editar"
                      ><b>Editar</b></a>
                    </li>
                    <li>
                      <a
                        class="btn btn-block boton_opciones"
                        data-toggle="modal"
                        data-target="#moda_historial_cliente"
                        @click="consultarDatosCliente(props.row.id)"
                      ><b>Historial</b></a>
                    </li>
                    <li>
                      <a
                        class="btn btn-block boton_opciones"
                        @click="eliminar_cliente(props.row.id)"
                        v-show="$store.state.global_privilegio_admin_registro_cliente.eliminar"
                      ><b>Eliminar</b></a>
                    </li>
                  </ul>
                </div>
              </v-client-table>
            </div>
            <!-- FIN LISTA DE CLIENTES -->
          </div>
        </div>
      </div>
    </div>

    <!-- Modal agregar cliente-->
    <div class="modal fade" id="agregarcliente" tabindex="-1" aria-labelledby="agregarclienteeeModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <label class="tituloEditar"><b>Datos Generales del Cliente</b></label>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="container-fluid">
              <form v-on:submit.prevent="agregar_cliente()">
                <div class="row">
                  <div class="col-5">
                    <label class="color_letra"
                      >Nombre del Cliente G4S *:</label
                    >
                    <input
                      v-model.trim.lazy="clientePrincipal.cl_cliente"
                      type="text"
                      class="form-control Mayus"
                      
                      required
                    />
                  </div>
                  <div class="col-3">
                    <label class="color_letra">NIT *:</label>
                    <input
                      v-model.trim.lazy="clientePrincipal.cl_nit_cliente"
                      type="text"
                      class="form-control"
                    />
                  </div>
                  <div class="col-4">
                    <label class="color_letra"
                      >Registro Único Empresarial:</label
                    >
                    <a
                      class="btn btn-warning"
                      href="https://www.rues.org.co/"
                      target="_blank"
                      style="width: 220px !important"
                      >Consultar</a
                    >
                  </div>
                  <div class="col-5 mt-2">
                    <label class="color_letra"
                      >Grupos Exposición Similar, GES *:</label
                    >
                    <select class="form-control" v-model="clientePrincipal.cl_sector">
                      <option value="" selected disabled>Seleccionar...</option>
                      <option value="Alimentos y Bebidas">
                        Alimentos y Bebidas
                      </option>
                      <option value="Automotriz">Automotriz</option>
                      <option value="Bancario y Financiero">
                        Bancario y Financiero
                      </option>
                      <option value="Comercial">Comercial</option>
                      <option value="Educativo">Educativo</option>
                      <option value="Floricultor">Floricultor</option>
                      <option value="Grandes Superficies">Grandes Superficies</option>
                      <option value="Industrial">Industrial</option>
                      <option value="Minero-Hidrocarburos">
                        Minero-Hidrocarburos
                      </option>
                      <option value="Obras Civiles">Obras Civiles</option>
                      <option value="Residencial">Residencial</option>
                      <option value="Salud">Salud</option>
                      <option value="Servicios">Servicios</option>
                      <option value="Zona Franca">Zona Franca</option>
                    </select>
                  </div>
                  <div class="col-4">
                    <label class="color_letra mt-2">Teléfono:</label>
                    <input
                      type="number"
                      min="1"
                      v-model.trim.lazy="clientePrincipal.cl_telefono"
                      class="form-control"
                    />
                  </div>
                  <div class="col-12 mt-3">
                    <label class="color_letra">
                      Contacto del Cliente
                    </label>
                  </div>
                  <div class="col-5">
                    <label class="color_letra"
                      >Nombre:</label
                    >
                    <input
                      type="text"
                      v-model.trim.lazy="clientePrincipal.cl_contacto"
                      class="form-control Mayus"
                    />
                  </div>
                  <div class="col-4">
                    <label class="color_letra">Cargo:</label>
                    <input
                      type="text"
                      v-model.trim.lazy="clientePrincipal.cl_cargo"
                      class="form-control Mayus"
                      placeholder="Cargo"
                    />
                  </div>
                  <div class="col-3">
                    <label class="color_letra">Celular:</label>
                    <input
                      type="number"
                      v-model.trim.lazy="clientePrincipal.cl_celular"
                      class="form-control"
                      placeholder="Celular"
                    />
                  </div>
                  <div class="col-5 mt-2">
                    <label class="color_letra">Correo:</label>
                    <input
                      type="email"
                      v-model.trim.lazy="clientePrincipal.cl_correo"
                      class="form-control"
                      placeholder="Correo"
                    />
                  </div>
                  <div class="col-4">
                    <div class="form-group">
                      <label class="color_letra mt-2">Logo Empresa</label>
                      <div class="input-group">
                        <label class="input-group-btn btn-block">
                          <span
                            class="btn btn-warning btn-block"
                            style="width: 220px !important"
                          >
                            Subir Imagen
                            <input
                              type="file"
                              accept="image/*"
                              @change="cargar_imagen($event.target.files[0])"
                              class="form-control"
                              style="display: none"
                            />
                          </span>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="col-3 mt-2">
                    <img v-if="clientePrincipal.cl_logo != ''"
                      id="contendor_tip_img"
                      :src="clientePrincipal.cl_logo"
                      class="img_fluid rounded"
                      style="width: 100%"
                    />
                  </div>
                  <div class="col-6">
                    <button type="button" class="btn btn-secondary btn-block" data-dismiss="modal" @click="resetForm()">Close</button>
                  </div>
                  <div class="col-6">
                    <button type="submit" class="btn boton_guardar1 btn-block">
                      Guardar
                    </button>
                  </div>
                </div>
              </form>             
            </div>
          </div>
        </div>
      </div>
    </div>

     <!-- Modal editar cliente-->
    <div class="modal fade" id="editarcliente" tabindex="-1" aria-labelledby="editarclienteLabel" aria-hidden="true">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <label class="tituloEditar"><b>Editar Datos del Cliente</b></label>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="container-fluid">
              <form v-on:submit.prevent="editar_cliente(idCliente)">
                <div class="row">
                  <div class="col-5">
                    <label class="color_letra"
                      >Nombre del Cliente G4S *:</label
                    >
                    <input
                      v-model.trim.lazy="clientePrincipalEditar.cl_cliente"
                      type="text"
                      class="form-control Mayus"
                      
                      required
                    />
                  </div>
                  <div class="col-3">
                    <label class="color_letra">NIT *:</label>
                    <input
                      v-model.trim.lazy="clientePrincipalEditar.cl_nit_cliente"
                      type="text"
                      class="form-control"
                    />
                  </div>
                  <div class="col-4">
                    <label class="color_letra"
                      >Registro Único Empresarial:</label
                    >
                    <a
                      class="btn btn-warning"
                      href="https://www.rues.org.co/"
                      target="_blank"
                      style="width: 220px !important"
                      >Consultar</a
                    >
                  </div>
                  <div class="col-5 mt-2">
                    <label class="color_letra"
                      >Grupos Exposición Similar, GES *:</label
                    >
                    <select class="form-control" v-model="clientePrincipalEditar.cl_sector">
                      <option value="" selected disabled>Seleccionar...</option>
                      <option value="Alimentos y Bebidas">
                        Alimentos y Bebidas
                      </option>
                      <option value="Automotriz">Automotriz</option>
                      <option value="Bancario y Financiero">
                        Bancario y Financiero
                      </option>
                      <option value="Comercial">Comercial</option>
                      <option value="Educativo">Educativo</option>
                      <option value="Floricultor">Floricultor</option>
                      <option value="Grandes Superficies">Grandes Superficies</option>
                      <option value="Industrial">Industrial</option>
                      <option value="Minero-Hidrocarburos">
                        Minero-Hidrocarburos
                      </option>
                      <option value="Obras Civiles">Obras Civiles</option>
                      <option value="Residencial">Residencial</option>
                      <option value="Salud">Salud</option>
                      <option value="Servicios">Servicios</option>
                      <option value="Zona Franca">Zona Franca</option>
                    </select>
                  </div>
                  <div class="col-4">
                    <label class="color_letra mt-2">Teléfono:</label>
                    <input
                      type="number"
                      min="1"
                      v-model.trim.lazy="clientePrincipalEditar.cl_telefono"
                      class="form-control"
                    />
                  </div>
                  <div class="col-12 mt-3">
                    <label class="color_letra">
                      Contacto del Cliente
                    </label>
                  </div>
                  <div class="col-5">
                    <label class="color_letra"
                      >Nombre:</label
                    >
                    <input
                      type="text"
                      v-model.trim.lazy="clientePrincipalEditar.cl_contacto"
                      class="form-control Mayus"
                    />
                  </div>
                  <div class="col-4">
                    <label class="color_letra">Cargo:</label>
                    <input
                      type="text"
                      v-model.trim.lazy="clientePrincipalEditar.cl_cargo"
                      class="form-control Mayus"
                      placeholder="Cargo"
                    />
                  </div>
                  <div class="col-3">
                    <label class="color_letra">Celular:</label>
                    <input
                      type="number"
                      v-model.trim.lazy="clientePrincipalEditar.cl_celular"
                      class="form-control"
                      placeholder="Celular"
                    />
                  </div>
                  <div class="col-5 mt-2">
                    <label class="color_letra">Correo:</label>
                    <input
                      type="email"
                      v-model.trim.lazy="clientePrincipalEditar.cl_correo"
                      class="form-control"
                      placeholder="Correo"
                    />
                  </div>
                  <div class="col-4">
                    <div class="form-group">
                      <label class="color_letra mt-2">Logo Empresa</label>
                      <div class="input-group">
                        <label class="input-group-btn btn-block">
                          <span
                            class="btn btn-warning btn-block"
                          >
                            Subir Imagen
                            <input
                              type="file"
                              accept="image/*"
                              @change="cargar_imagenEditar($event.target.files[0])"
                              class="form-control"
                              style="display: none"
                            />
                          </span>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="col-3 mt-2">
                    <img v-if="clientePrincipalEditar.cl_logo != ''"
                      id="contendor_tip_img"
                      :src="clientePrincipalEditar.cl_logo"
                      class="img_fluid rounded"
                      style="width: 100%"
                    />
                  </div>
                  <div class="col-6">
                    <button type="button" class="btn btn-secondary btn-block" data-dismiss="modal" @click="resetForm()">Close</button>
                  </div>
                  <div class="col-6">
                    <button type="submit" class="btn boton_guardar1 btn-block">
                      Guardar
                    </button>
                  </div>
                </div>
              </form>             
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL CAMBIO DE ESTADO CLIENTE A SIN SERVICIO -->
    <div
      class="modal fade" id="estadoClienteSin" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <label class="tituloEditar"><b>Confirmación Cambio de Estado</b></label>
          </div>
          <div class="modal-body">
            Al confirmar, este cliente pasará automáticamente al estado sin
            servicio. Los demás usuarios no podrán crear matriz de peligros para
            este cliente.
            <hr />
            <center>
              <button
                type="button"
                class="btn boton_cancelar mr-3"
                style="width: 200px !important"
                data-dismiss="modal"
              >
                Cancelar
              </button>
              <button
                type="button"
                class="btn boton_guardar1"
                style="width: 200px !important"
                @click="editarEstadoCliente(idCliente)"
              >
                Confirmar
              </button>
            </center>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL CAMBIO DE ESTADO CLIENTE A CON SERVICIO -->
    <div
      class="modal fade" id="estadoClienteCon" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <label class="tituloEditar"><b>Confirmación Cambio de Estado</b></label>
          </div>
          <div class="modal-body">
            Al confirmar, este cliente pasará automáticamente al estado en
            servicio. Los demás usuarios podrán crear matriz de peligros para
            este cliente. {{ idCliente }}
            <hr />
            <center>
              <button
                type="button"
                class="btn boton_cancelar mr-3"
                style="width: 200px !important"
                data-dismiss="modal"
              >
                Cancelar
              </button>
              <button
                type="button"
                class="btn boton_guardar1"
                style="width: 200px !important"
                @click="editarEstadoClienteSin(idCliente)"
              >
                Confirmar
              </button>
            </center>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL HISTORIAL -->
    <div
      class="modal fade"
      id="moda_historial_cliente"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-body">
            <label class="tituloEditar"><b>Historial <br> {{ nombreCliente }} NIT: {{ nitCliente }}</b></label>
            <br />
            <div class="table table-responsive">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th scope="col">Cliente</th>
                    <th scope="col">NIT</th>
                    <th scope="col">GES</th>
                    <th scope="col">Teléfono</th>
                    <th scope="col">Contacto</th>
                    <th scope="col">Cargo</th>
                    <th scope="col">Correo</th>
                    <th scope="col">Celular</th>
                    <th scope="col">Fecha</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item1, index) of array_historial"
                    :key="index"
                  >
                    <td>{{ item1.cliente }}</td>
                    <td>{{ item1.nit_cliente }}</td>
                    <td>{{ item1.ges }}</td>
                    <td>{{ item1.telefono }}</td>
                    <td>{{ item1.contacto }}</td>
                    <td>{{ item1.cargo }}</td>
                    <td>{{ item1.correo }}</td>
                    <td>{{ item1.celular }}</td>
                    <td>
                      {{ item1.fecha_agregado }}-{{ item1.hora_agregado }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <center>
              <button
                type="button"
                class="btn boton_guardar"
                data-dismiss="modal"
                style="width: 220px !important"
              >
                Cerrar
              </button>
            </center>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL PARA EL LOGO DE LA EMPRESA -->
    <div class="modal" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body">
              <canvas id="canvas" width="100%" height="100%"></canvas>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL DESCARGAR EXCEL -->
    <div
      class="modal fade"
      id="descargarexcel"
      data-backdrop="static"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-xl modal-dialog-scrollable"
        role="document"
      >
        <div class="modal-content container_admin">
          <div class="modal-header">
            <h5 class="modal-title titulos" id="exampleModalLabel">
              Lista de Clientes
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <br />
          <div class="row">
            <div class="col-md-6">
              <a
                href="#"
                id="test"
                type="button"
                class="btn boton_descargar"
                @click="fnExcelReport()"
              >
                Descargar Excel
              </a>
            </div>
            <div class="col-md-6">
              <button
                type="button"
                class="btn boton_cancelar_excel"
                data-dismiss="modal"
              >
                Cancelar
              </button>
            </div>
          </div>
          <div class="modal-body">
            <table class="table table-bordered" id="myTable">
              <thead class="tabla">
                <tr>
                  <th scope="col" style="border: black 1px solid">Cliente</th>
                  <th scope="col" style="border: black 1px solid">NIT</th>
                  <th scope="col" style="border: black 1px solid">GES</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item3, index) of array_excel" :key="index">
                  <td style="border: black 1px solid">
                    {{ item3.cliente_excel }}
                  </td>
                  <td style="border: black 1px solid">{{ item3.nit_excel }}</td>
                  <td style="border: black 1px solid">{{ item3.ges_excel }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- NO TIENE PERMISO PARA VER EL MÓDULO -->
  <div class="alert alert-warning" role="alert" v-else>
    No tiene permiso para ver el Módulo
  </div>
</template>

<script>
// IMPORTACIÓN DE FIREBASE
import { firebase, auth, db } from "../../firebase";
import { storage } from '@/firebase';
// IMPORTACIÓN DE SWEET ALERT
import Swal from "sweetalert2";
import AdminMenu from "@/components/AdminMenu.vue";
// import NProgress from "nprogress";
// import "nprogress/nprogress.css";

export default {
  name: "Clientes",
  components: {
    AdminMenu,
  },
  data() {
    return {
      // VARIABLES PARA LA TABLA ADMIN DE CLIENTES
      informacion: [],
      columns: [
        "cliente",
        "nit_cliente",
        "sector",
        "contacto",
        "cargo",
        "correo",
        "celular",
        "estado",
        "opciones",
      ],
      options: {
        headings: {
          cliente: "Cliente",
          nit_cliente: "Nit",
          sector: "Ges",
          contacto: "Contacto",
          cargo: "Cargo",
          correo: "Correo",
          celular: "Celular",
          estado: "Estado",
          opciones: "Opciones",
        },
        sortable: [
          "cliente",
          "nit",
          "sector",
          "contacto",
          "cargo",
          "correo",
          "celular",
        ],
        filterable: true, // Habilitar filtro en todas las columnas
        texts: {
          filter: "Buscar",
          filterPlaceholder: "",
        },
        filterOptions: {
          placeholder: 'Buscar en todas las columnas',
          trigger: 'enter' // Opcional: Filtra al presionar Enter
        },
        perPage: 10, // Configuración opcional: Número de filas por página
        perPageValues: [10, 20, 50], // Configuración opcional: Opciones de filas por página
      },
      
      // VARIABLES REGISTRO CLIENTE
      clientePrincipal: {
        cl_cliente: "",
        cl_nit_cliente: "",
        cl_contacto: "",
        cl_cargo: "",
        cl_correo: "",
        cl_celular: "",
        cl_telefono: "",
        cl_sector: "",
        cl_registrado_por: "",
        cl_estado: "En Servicio",
        cl_fecha: "",
        cl_hora_actual: "",
        cl_logo: "",
      },

      idCliente : "",

      // VARIABLES DEL HISTORIAL
      clienteHistorial: {
        h_cliente_id: "",
        h_cliente: "",
        h_nit_cliente: "",
        h_contacto: "",
        h_cargo: "",
        h_correo: "",
        h_celular: "",
        h_telefono: "",
        h_sector: "",
        h_registrado_por: "",
        h_estado: "",
        h_fecha: "",
        h_hora: "",
      },
    
      // VARIABLES EDITAR CLIENTE
      clientePrincipalEditar: "",
      clientePrincipalHistorial: "",

      // DATOS HISTORIAL
      nombreCliente: "",
      nitCliente: "",
      array_historial: [],
      
      // DATOS EXCEL
      array_excel: [],
    };
  },
  created() {
    if (
      this.$store.state.global_privilegio_admin_registro_cliente.ver) {
      this.tabla_cliente();
    }
  },
  methods: {
    formatDate(date) {
      const d = date.getDate();
      const m = date.getMonth() + 1;
      const y = date.getFullYear();
      return `${d}/${m}/${y}`;
    },

    formatTime(date) {
      const horas = date.getHours();
      const minutos = date.getMinutes();
      const segundos = date.getSeconds();
      return `${horas}:${minutos}:${segundos}`;
    },

    // Subir imagen
    async cargar_imagen(file) {
      this.$isLoading(true);
      // this.seccion.imagen.tipo = "Imagen",
      this.url = URL.createObjectURL(file);
      
      let urlDescarga;
      const archivoRef = storage.ref().child(`files/clientePrincipal/${new Date()}` + file.name);
      
      try {
          // Subir el archivo al almacenamiento
          urlDescarga = await archivoRef.put(file);
          // Obtener la URL de descarga del archivo
          const downloadURL = await archivoRef.getDownloadURL();
          this.clientePrincipal.cl_logo = downloadURL
          Swal.fire({
              icon: "success",
              title: "¡Imagen adjuntada!",
              showConfirmButton: false,
              timer: 1900,
              customClass: {
                  popup: "swal2-border-radius",
              },
          });
      } catch (error) {
          console.error('Error al subir el archivo:', error);
      }         
      this.$isLoading(false);
    },

    // subir imagen editar
    async cargar_imagenEditar(file) {
      this.clientePrincipalEditar.cl_logo = "";
      this.$isLoading(true);
      // this.seccion.imagen.tipo = "Imagen",
      this.url = URL.createObjectURL(file);
      
      let urlDescarga;
      const archivoRef = storage.ref().child(`files/clientePrincipal/${new Date()}` + file.name);
      
      try {
          // Subir el archivo al almacenamiento
          urlDescarga = await archivoRef.put(file);
          // Obtener la URL de descarga del archivo
          const downloadURL = await archivoRef.getDownloadURL();
          this.clientePrincipalEditar.cl_logo = downloadURL
          Swal.fire({
              icon: "success",
              title: "¡Imagen adjuntada!",
              showConfirmButton: false,
              timer: 1900,
              customClass: {
                  popup: "swal2-border-radius",
              },
          });
      } catch (error) {
          console.error('Error al subir el archivo:', error);
      }         
      this.$isLoading(false);
    },

    // TABLA CLIENTES
    async tabla_cliente() {
      try {
        this.$isLoading(true);
        if (this.informacion.length === 0) {
          this.informacion = [];

          db.collection("cliente_principal")
            .orderBy("cl_fecha", "asc")
            .onSnapshot((snapshot) => {
              snapshot.docChanges().forEach((change) => {
                const docData = {
                  id: change.doc.id,
                  cliente: change.doc.data().cl_cliente,
                  nit_cliente: change.doc.data().cl_nit_cliente,
                  sector: change.doc.data().cl_sector,
                  contacto: change.doc.data().cl_contacto,
                  celular: change.doc.data().cl_celular,
                  cargo: change.doc.data().cl_cargo,
                  correo: change.doc.data().cl_correo,
                  estado_cliente: change.doc.data().cl_estado,
                };

                if (change.type === "added") {
                  this.informacion.unshift(docData);
                } else if (change.type === "modified") {
                  const index = this.informacion.findIndex(item => item.id === change.doc.id);
                  if (index !== -1) {
                    this.informacion.splice(index, 1, docData);
                  }
                } else if (change.type === "removed") {
                  const index = this.informacion.findIndex(item => item.id === change.doc.id);
                  if (index !== -1) {
                    this.informacion.splice(index, 1);
                  }
                }

                // Eliminar duplicados basados en IDs
                const uniqueIds = new Set();
                this.informacion = this.informacion.filter(item => {
                  if (uniqueIds.has(item.id)) {
                    return false;
                  } else {
                    uniqueIds.add(item.id);
                    return true;
                  }
                });

                this.$isLoading(false);
              });
            });
        }
      } catch (error) {
        console.error("Error fetching client data: ", error);
        this.$isLoading(false);
      }
    },

    // FUNCIÓN PARA AGREGAR A LA BASE DE DATOS CLIENTE
    async agregar_cliente() {
      try {
        // NProgress.start();
        this.$isLoading(true);

        // Obtener fecha y hora actual
        const now = new Date();
        this.clientePrincipal.cl_fecha = this.formatDate(now);
        this.clientePrincipal.cl_hora_actual = this.formatTime(now);
        this.clientePrincipal.cl_registrado_por = this.$store.state.email;

        // Generar nuevo documento con ID automático
        const newClienteRef = db.collection("cliente_principal").doc();
        const id = newClienteRef.id;

        // Guardar cliente
        await newClienteRef.set(this.clientePrincipal);

        // await this.agregar_historial(id);
        this.$isLoading(false);
        Swal.fire({
          icon: "success",
          title: "¡Cliente agregado!",
          showConfirmButton: false,
          timer: 1900,
          customClass: {
              popup: "swal2-border-radius",
          },
        });

        // Cerrar modal
        $("#agregarcliente").modal("hide");
        // NProgress.done();
      } catch (error) {
        console.error("Error al agregar cliente: ", error);
        this.$isLoading(false);
        // NProgress.done();
      }
    },
    resetForm() {
      this.clientePrincipal = {
        cl_cliente: "",
        cl_nit_cliente: "",
        cl_contacto: "",
        cl_cargo: "",
        cl_correo: "",
        cl_celular: "",
        cl_telefono: "",
        cl_sector: "",
        cl_registrdo_por: "",
        cl_estado: "En Servicio",
        cl_fecha: "",
        cl_hora_actual: "",
        cl_logo: "",
      }
      this.clientePrincipalEditar = {
        cl_cliente: "",
        cl_nit_cliente: "",
        cl_contacto: "",
        cl_cargo: "",
        cl_correo: "",
        cl_celular: "",
        cl_telefono: "",
        cl_sector: "",
        cl_registrdo_por: "",
        cl_estado: "En Servicio",
        cl_fecha: "",
        cl_hora_actual: "",
        cl_logo: "",
      }
    },

    // FUNCIÓN PARA MOSTRAR DATOS CLIENTE
    async consultar_cliente(id_cliente) {
      try {
        // NProgress.start();
        this.$isLoading(true);

        let docRef = db.collection("cliente_principal").doc(id_cliente);
        let doc = await docRef.get();

        if (doc.exists) {
          this.idCliente = id_cliente
          this.clientePrincipalHistorial = doc.data();
          this.clientePrincipalEditar = doc.data();

          // console.log('datos historial', this.clientePrincipalHistorial)

          // $("#editarcliente").modal("show");
        } else {
          console.error("No se encontró el documento.");
        }
        this.$isLoading(false);
        // NProgress.done();
      } catch (error) {
        console.error("Error al consultar el cliente: ", error);
        this.$isLoading(false);
        // NProgress.done();
      }
    },

    // FUNCIÓN PARA EDITAR CLIENTE
    async editar_cliente(key) {
      try {
        // NProgress.start();
        this.$isLoading(true);

        await this.agregar_historial(key);

        // FUNCIÓN PARA EDITAR
        await db.collection("cliente_principal")
          .doc(key)
          .set(this.clientePrincipalEditar);

        this.$isLoading(false);
        // NProgress.done();
        Swal.fire({
          icon: "success",
          title: "¡Cliente editado correctamente!",
          showConfirmButton: false,
          timer: 1900,
          customClass: {
              popup: "swal2-border-radius",
          },
        });
         // Limpiar formularios
         this.resetForm();
        $("#editarcliente").modal("hide");
      } catch (error) {
        console.error("Error al editar el cliente: ", error);
        this.$isLoading(false);
        // NProgress.done();
      }
    },
    async agregar_historial(id_cliente) {
      const now = new Date();
      try {
        // Obtener referencia del nuevo documento
        const newHistorialRef = db.collection("historial_cliente").doc();
        const id_historial = newHistorialRef.id;

        // Guardar historial
        await newHistorialRef.set({
          h_cliente_id: id_cliente,
          h_cliente: this.clientePrincipalHistorial.cl_cliente,
          h_nit_cliente: this.clientePrincipalHistorial.cl_nit_cliente,
          h_contacto: this.clientePrincipalHistorial.cl_contacto,
          h_cargo: this.clientePrincipalHistorial.cl_cargo,
          h_correo: this.clientePrincipalHistorial.cl_correo,
          h_celular: this.clientePrincipalHistorial.cl_celular,
          h_telefono: this.clientePrincipalHistorial.cl_telefono,
          h_sector: this.clientePrincipalHistorial.cl_sector,
          h_registrado_por: this.clientePrincipalHistorial.cl_registrado_por,
          h_estado: this.clientePrincipalHistorial.cl_estado,
          h_fecha_agregado: this.formatDate(now),
          h_hora_agregado: this.formatTime(now),
        });

      } catch (error) {
        console.error("Error al agregar historial del cliente: ", error);
      }
    },


    // HISTORIAL DEL CLIENTE CON ESTADO CON SERVICIO
    async editarEstadoCliente(key) {

      var washingtonRef = db.collection("cliente_principal").doc(key);

      // Set the "capital" field of the city 'DC'
      return washingtonRef.update({
          cl_estado: 'Sin Servicio'
      })
      .then(async() => {
          // console.log("Document successfully updated!");
          await this.agregar_historial(key)
          $("#estadoClienteSin").modal("hide");
      })
      .catch((error) => {
          // The document probably doesn't exist.
          console.error("Error updating document: ", error);
      });
    },

    async editarEstadoClienteSin(key) {
      var washingtonRef = db.collection("cliente_principal").doc(key);

      // Set the "capital" field of the city 'DC'
      return washingtonRef.update({
          cl_estado: 'En Servicio'
      })
      .then(async() => {
          // console.log("Document successfully updated!");
          await this.agregar_historial(key)
          $("#estadoClienteCon").modal("hide");
      })
      .catch((error) => {
          // The document probably doesn't exist.
          console.error("Error updating document: ", error);
      });
    },


    // FUNCIÓN PARA MOSTRAR ID DEL CLIENTE
    consultarDatosCliente(id_cliente) {
      // console.log(id_cliente)
      let docRef = db.collection("cliente_principal").doc(id_cliente);
      docRef.get().then((doc) => {
        if (doc.exists) {
          this.datosClienteHistorial = doc.data();
        }
        this.consultar_historial(id_cliente, this.datosClienteHistorial);
      });
    },

    // FUNCIÓN PARA MOSTRAR DATOS DEL HISTORIAL
    consultar_historial(key_cliente, datosClientes) {
      this.nombreCliente = datosClientes.cl_cliente,
      this.nitCliente = datosClientes.cl_nit_cliente,
      this.array_historial = [];
      let historialModificado = db.collection("historial_cliente");
      historialModificado
        .where("h_cliente_id", "==", key_cliente)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.array_historial.push({
              id_historial: doc.id,
              cliente: doc.data().h_cliente,
              nit_cliente: doc.data().h_nit_cliente,
              ges: doc.data().h_sector,
              telefono: doc.data().h_telefono,
              contacto: doc.data().h_contacto,
              cargo: doc.data().h_cargo,
              correo: doc.data().h_correo,
              celular: doc.data().h_celular,
              estado: doc.data().h_estado,
              fecha_agregado: doc.data().h_fecha_agregado,
              hora_agregado: doc.data().h_hora_agregado,
            });
          });
          // console.log(this.array_historial)
        })
        .catch((error) => {});
    },

    // FUNCIÓN PARA ELIMINAR CONTROL EXISTENTE
    async eliminar_cliente(key) {
      Swal.fire({
        title: "¿Seguro que desea aliminar este cliente?",
        text: "¡Una vez eliminado, se borrará permanentemente el cliente!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sí, Eliminar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          db.collection("cliente_principal")
            .doc(key)
            .delete()
            .then(() => {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "Datos eliminados satisfactoriamente.",
                showConfirmButton: false,
                timer: 1500,
                allowOutsideClick: false,
                allowEscapeKey: false,
              });
            });
        }
      });
    },

    //MOSTRART EXCEL
    async descargar_excel() {
      this.array_excel = [];
      db.collection("cliente_principal")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.array_excel.push({
              cliente_excel: doc.data().cl_cliente,
              nit_excel: doc.data().cl_nit_cliente,
              ges_excel: doc.data().cl_sector,
            });
          });
        })
        .catch((error) => {});
    },

    fnExcelReport() {
      var tab_text =
        '<html xmlns:o="urn:schemas-microsoft-com:office:excel" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40" <meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8">>';
      tab_text =
        tab_text +
        "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
      tab_text = tab_text + "<x:Name>Matriz de riesgo</x:Name>";
      tab_text =
        tab_text +
        "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
      tab_text =
        tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
      tab_text = tab_text + "<table border='0px !important;'>";

      //get table HTML code
      tab_text = tab_text + $("#myTable").html();
      tab_text = tab_text + "</table></body></html>";

      var data_type = 'data:application/vnd.ms-excel;base64"';

      var ua = window.navigator.userAgent;
      var msie = ua.indexOf("MSIE ");
      //For IE
      if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
        if (window.navigator.msSaveBlob) {
          var blob = new Blob([tab_text], {
            type: "application/csv;",
          });
          navigator.msSaveBlob(blob, "Test file.xls");
        }
      }
      //for Chrome and Firefox
      else {
        $("#test").attr(
          "href",
          data_type + ", " + encodeURIComponent(tab_text)
        );
        $("#test").attr("download", "Matriz Riesgo.xls");
      }
    },
  },
};
</script>
<style scoped>
.tituloEditar {
  font-family: AllThings;
  text-align: center;
  font-size: 2em;
  font-weight: 400;
}
</style>